import { render, staticRenderFns } from "./comment-box.vue?vue&type=template&id=6b5b389c&"
import script from "./comment-box.vue?vue&type=script&lang=js&"
export * from "./comment-box.vue?vue&type=script&lang=js&"
import style0 from "./comment-box.vue?vue&type=style&index=0&id=6b5b389c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports